import { render, staticRenderFns } from "./HomeInformation.vue?vue&type=template&id=a2905306&scoped=true&"
import script from "./HomeInformation.vue?vue&type=script&lang=ts&"
export * from "./HomeInformation.vue?vue&type=script&lang=ts&"
import style0 from "./HomeInformation.vue?vue&type=style&index=0&id=a2905306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2905306",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VRow})
